import { addMinutes  , 
         addHours    ,
         addDays     ,		 
		 addWeeks    ,		 
		 addMonths   ,		 
		 addYears    ,		 
         subDays     ,		 
		 isBefore    , 
		 isEqual     , 
		 isAfter     , 
		 format      , 
		 parse       ,
		 startOfWeek ,
		 startOfDay  } from 'date-fns';

import { formatInTimeZone  }  from 'date-fns-tz'

import { fr } from "date-fns/locale";

export const timeStepNames: string [] = [  '1 minute'   , 
                                           '5 minutes'  , 
                                          '10 minutes'  , 
										   '1 heure'    , 
										   '6 heures'   , 
										  '12 heures'   , 
										   '1 jour'     , 
										   '1 semaine'  , 
										   '2 semaines' ,
										   '1 mois'     ,
										   '6 mois'     ,
										   '1 an'       ]


export const timeStepTitles: string [] = [ 'par minute'   ,
                                           'par tranche de 5 minutes'  ,
                                           'par tranche de 10 minutes'  ,
										   'par heure'    ,
										   'par tranche de 6 heures'   ,
										   'par tranche de 12 heures'   ,
										   'par jour'     ,
										   'par semaine'  ,
										   'par tranche de 2 semaines' ,
										   'par mois'     ,
										   'par tranche de 6 mois'     ,
										   'par an'       ]

export const convertStringToDate = (str: string, specifiedFormat: string = ''): Date | null => {

  if (!str || typeof str !== 'string') {
    return null;
  }

  /*
  // Vérifiez si la chaîne est dans un format ISO valide
  const isoDate = new Date(str);
  if (!isNaN(isoDate.getTime())) {
  //  console.log('Parsed using ISO format');
    return isoDate;
  }
  */

  const formatsToTry = [
    'yyyy/MM/dd HH:mm:ss',
    'yyyy/MM/dd',
    'yyyy-MM-dd HH-mm-ss',
    'yyyy-MM-dd HH:mm:ss',
    'yyyy-MM-dd',
    'dd/MM/yyyy HH:mm:ss',
    'dd/MM/yyyy',
    'MM/dd/yyyy HH:mm:ss',
    "yyyy-MM-dd'T'HH:mm:ssXXX"
  ];

  if ( specifiedFormat !== '' )
        {
         const parsedDate = parse(str, specifiedFormat, new Date());

         if (!isNaN(parsedDate.getTime()))
          {
           return parsedDate;
          }
        }
   else {
         for (const format of formatsToTry)
          {
           const parsedDate = parse(str, format, new Date());

           if (!isNaN(parsedDate.getTime()))
            {
             return parsedDate;
            }
          }
        }

  return null;
};

export const convertDateToString = ( date:         Date | null                                               ,
                                     formatString: string = 'yyyy/MM/dd HH:mm:ss'                            ,
                                     timeZone:     string = Intl.DateTimeFormat().resolvedOptions().timeZone ): string => {
	
// export const convertDateToString = ( date:         Date | null                    ,
                                     // formatString: string = 'yyyy/MM/dd HH:mm:ss' ,
                                     // timeZone:     string = 'Europe/Paris' ): string => {

  if (date === null) {
    return '';
  }

  if ( timeZone !== '' )
   {
    const rawFormatted   = formatInTimeZone(date, timeZone, formatString, { locale: fr });
    const finalFormatted = rawFormatted.charAt(0).toUpperCase() + rawFormatted.slice(1);

    return finalFormatted

   }

  const chaine       = format(date as Date, formatString, { locale: fr });
  const chaineFinale = chaine.charAt(0).toUpperCase() + chaine.slice(1);

  return chaineFinale
};

/*
export const parseServerDateFull = ( input   : { date          : string ; 
											     timezone_type : number ; 
											     timezone      : string } ,
                                    timeZone :   string = 'Europe/Paris'  ): Date | null => {

  const { date, timezone_type, timezone } = input;

  if (!date || typeof date !== 'string' || typeof timezone !== 'string' || typeof timezone_type !== 'number') {
    console.warn('Champ(s) manquant(s) ou invalide(s)', input);
    return null;
  }

  const cleanedDateStr = date.replace(/\.\d{6}$/, '');
  const serverFormat = 'yyyy-MM-dd HH:mm:ss';

  return convertStringToDate(cleanedDateStr, serverFormat);
};
*/

export  const convertDateToSeconds = (dateString: string): number => {
  // Définir le format de la date d'entrée
  const formatString = 'dd/MM/yyyy';

  // Utiliser `parse` pour convertir la chaîne de caractères en objet Date
  const parsedDate = parse(dateString, formatString, new Date());

  // Vérifier si la date est invalide
  if (isNaN(parsedDate.getTime())) {
    throw new Error('Invalid date format');
  }

  // Calculer le nombre de secondes depuis le 1er janvier 1970 (epoch)
  const seconds = Math.floor(parsedDate.getTime() / 1000);

  return seconds;
};


/*
export const timeStringToSeconds = (time: string): number => {
  const [hours, minutes, seconds] = time.split(':').map(Number);
  return (hours || 0) * 3600 + (minutes || 0) * 60 + (seconds || 0);
};
*/


export const timeStringToSeconds = (time: string): number => {
  const [hours, minutes, seconds] = time.split(':').map(Number);
  return (hours || 0) * 3600 + (minutes || 0) * 60 + (seconds || 0);
};

export const timeSecondsToString = (totalSeconds: number, formatStr: string = "HH:mm:ss"): string => {

  if (totalSeconds < 0) return "Invalid time";

  const date = new Date(0); // Date de base (1er janvier 1970)
  date.setSeconds(totalSeconds);

  return format(date, formatStr);
};

export const addTimeStep = (date: Date, timeStep: string): Date => {
  const newDate = new Date(date); // Copier la date pour éviter les modifications directes

  switch (timeStep) {
    case "1 minute":
      newDate.setMinutes(newDate.getMinutes() + 1);
      break;
    case "5 minutes":
      newDate.setMinutes(newDate.getMinutes() + 5);
      break;
    case "10 minutes":
      newDate.setMinutes(newDate.getMinutes() + 10);
      break;
    case "1 heure":
      newDate.setHours(newDate.getHours() + 1);
      break;
    case "6 heures":
      newDate.setHours(newDate.getHours() + 6);
      break;
    case "12 heures":
      newDate.setHours(newDate.getHours() + 12);
      break;
    case "1 jour":
      newDate.setDate(newDate.getDate() + 1);
      break;
    case "1 semaine":
      newDate.setDate(newDate.getDate() + 7);
      break;
    case "2 semaines":
      newDate.setDate(newDate.getDate() + 14);
      break;
    case "1 mois":
      newDate.setMonth(newDate.getMonth() + 1);
      break;
    case "6 mois":
      newDate.setMonth(newDate.getMonth() + 6);
      break;
    case "1 an":
      newDate.setFullYear(newDate.getFullYear() + 1);
      break;
    default:
      throw new Error(`Unsupported timeStep: ${timeStep}`);
  }

  return newDate;
};











export const durationNames: string [] = timeStepNames



/*
interface ParsedTime {
    quantite:  number | null;
    unite:     string | null;
    direction: string | null;
}

const parseTimeString = (chaine: string): ParsedTime => {

    const match = chaine.match(/(\d+)\s*(minute?|minutes?|heure?|heures?|jour?|jours?|semaine?|semaines?|mois?|an?|ans?)\s*(avant|après)/i);

    if (match) 
	 {
      return {
              quantite:  parseInt (match[1]),
              unite:     match[2],
              direction: match[3],
             };
     }
	 
    return {
            quantite:  null,
            unite:     null,
            direction: null,
           };
    };

export const modifyDate2 = ( date:     Date    , 
                             interval: string  ): Date => {

    const parsedInterval = parseTimeString (interval)
	
	if ( parsedInterval.direction === 'avant' )
	      {
	            if ( parsedInterval.unite.startsWith ('minute')  ) { return subMinutes ( date , parsedInterval.quantite ); }
	       else if ( parsedInterval.unite.startsWith ('heure')   ) { return subHours   ( date , parsedInterval.quantite ); }
	       else if ( parsedInterval.unite.startsWith ('jour')    ) { return subDays    ( date , parsedInterval.quantite ); }
	       else if ( parsedInterval.unite.startsWith ('semaine') ) { return subWeeks   ( date , parsedInterval.quantite ); }
	       else if ( parsedInterval.unite.startsWith ('mois')    ) { return subMonths  ( date , parsedInterval.quantite ); }
	       else if ( parsedInterval.unite.startsWith ('an')      ) { return subYears   ( date , parsedInterval.quantite ); }
		   else                                                    { return subMinutes ( date , parsedInterval.quantite ); }
	      }
	 else {
	            if ( parsedInterval.unite.startsWith ('minute')  ) { return addMinutes ( date , parsedInterval.quantite ); }
	       else if ( parsedInterval.unite.startsWith ('heure')   ) { return addHours   ( date , parsedInterval.quantite ); }
	       else if ( parsedInterval.unite.startsWith ('jour')    ) { return addDays    ( date , parsedInterval.quantite ); }
	       else if ( parsedInterval.unite.startsWith ('semaine') ) { return addWeeks   ( date , parsedInterval.quantite ); }
	       else if ( parsedInterval.unite.startsWith ('mois')    ) { return addMonths  ( date , parsedInterval.quantite ); }
	       else if ( parsedInterval.unite.startsWith ('an')      ) { return addYears   ( date , parsedInterval.quantite ); }
		   else                                                    { return addMinutes ( date , parsedInterval.quantite ); }
	      }
}
*/

export const modifyDate = ( date:     Date    , 
                            interval: string  ): Date => {

    const negative = interval.startsWith('-')
	const value    = negative ? interval.substring(1) : interval

	switch (value) 
	 {
      case  '1 minute'   : return addMinutes ( date ,  1 * ( negative ? -1 : 1 ) );
      case  '5 minutes'  : return addMinutes ( date ,  5 * ( negative ? -1 : 1 ) ); 
      case '10 minutes'  : return addMinutes ( date , 10 * ( negative ? -1 : 1 ) ); 
      case  '1 heure'    : return addHours   ( date ,  1 * ( negative ? -1 : 1 ) ); 
      case  '6 heures'   : return addHours   ( date ,  6 * ( negative ? -1 : 1 ) ); 
      case '12 heures'   : return addHours   ( date , 12 * ( negative ? -1 : 1 ) ); 
      case  '1 jour'     : return addDays    ( date ,  1 * ( negative ? -1 : 1 ) ); 
      case  '2 jours'    : return addDays    ( date ,  2 * ( negative ? -1 : 1 ) ); 
      case  '1 semaine'  : return addWeeks   ( date ,  1 * ( negative ? -1 : 1 ) ); 
      case  '2 semaines' : return addWeeks   ( date ,  2 * ( negative ? -1 : 1 ) ); 
      case  '1 mois'     : return addMonths  ( date ,  1 * ( negative ? -1 : 1 ) ); 
      case  '6 mois'     : return addMonths  ( date ,  6 * ( negative ? -1 : 1 ) );
      case  '1 an'       : return addYears   ( date ,  1 * ( negative ? -1 : 1 ) );
      default            : return addMinutes ( date ,  1 * ( negative ? -1 : 1 ) );
     }
}

export const modifyDateStr = ( dateStr:    string  , 
                               dateFormat: string  , 
                               interval:   string  ): string => {

    const date = parse ( dateStr, dateFormat, new Date() );

    const newDate = modifyDate ( date , interval )

    return format ( newDate , dateFormat );
}

export const getYesterdayMidnight = (): string => {

  const now = new Date();
  const yesterdayMidnight = startOfDay(subDays(now, 1));
  return format(yesterdayMidnight, 'yyyy/MM/dd HH:mm');
};

export const isBetween = ( date:  Date ,
                           date1: Date ,
				           date2: Date ) : boolean => {
				  
    return ( isAfter  ( date , date1 ) || 
	         isEqual  ( date , date1 ) )   && 
			 isBefore ( date , date2 )
}

export const getDateForDayAndTime = ( day:  string , 
                                      time: string ): Date | null => {

    const daysOfWeek = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];
    const dayIndex = daysOfWeek.indexOf(day.toLowerCase());

    if (dayIndex === -1) {
        return null;
    }

    const currentDate = new Date();
    const startOfCurrentWeek = startOfWeek(currentDate, { weekStartsOn: 1 }); // Commence la semaine le lundi
    const targetDay = addDays(startOfCurrentWeek, dayIndex);

    const [hours, minutes] = time.split(':').map(Number);
    targetDay.setHours(hours);
    targetDay.setMinutes(minutes);

    return targetDay;
}

// Gardes `|| 0` alignées sur timeStringToSeconds (ci-dessus) : sans elles, une chaîne vide
// ou malformée renvoyait NaN. C'est un cas réel — l'enrichissement des programmes fait
// `medias.find(...) || initializedMedia()`, dont la durée vaut "" quand le média n'est pas
// dans la liste chargée. Le NaN se propageait ensuite à tous les calculs d'heure de
// diffusion (dates "Invalid Date"), là où admin-api renvoie 0 dans le même cas
// (getMediaDurationInSeconds).
export const convertTimeToSeconds = ( time: string ): number => {

    const [hours, minutes, seconds] = (time ?? '').split(':').map(Number);
    return (hours || 0) * 3600 + (minutes || 0) * 60 + (seconds || 0);
};


export const formatDurationInSeconds = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  const formattedHours   = Number.isNaN(hours)   ? "" : hours.toString().padStart(2, '0');
  const formattedMinutes = Number.isNaN(minutes) ? "" : minutes.toString().padStart(2, '0');
  const formattedSeconds = Number.isNaN(secs)    ? "" : secs.toString().padStart(2, '0');

  return (formattedHours !== "" && formattedMinutes !== "" && formattedSeconds !== "") ?`${formattedHours}:${formattedMinutes}:${formattedSeconds}` : ""
};

export const formatDurationInMinutes = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const minuts = Math.floor(minutes % 60);

  const formattedHours   = Number.isNaN(hours)    ? "" : hours.toString().padStart(2, '0');
  const formattedMinutes = Number.isNaN(minuts)   ? "" : minuts.toString().padStart(2, '0');

  return ( formattedHours !== "" && formattedMinutes !== "" ) ? `${formattedHours}:${formattedMinutes}` : ""
};



// Fonction utilitaire pour convertir une durée ISO 8601 en hh:mm:ss
export const formatDurationFromIso = (isoDuration: string): string => {
  // Utiliser une RegExp pour extraire les heures, minutes et secondes
  const match = isoDuration.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/);

  if (!match) {
    return '00:00:00'; // Retourne une valeur par défaut si le format est invalide
  }

  // Extraire les heures, minutes et secondes, et les convertir en entiers
  const hours = parseInt(match[1] || '0', 10);
  const minutes = parseInt(match[2] || '0', 10);
  const seconds = parseInt(match[3] || '0', 10);

  // Fonction pour formater les nombres en ajoutant un zéro si nécessaire
  const pad = (num: number) => String(num).padStart(2, '0');

  // Retourner la durée sous la forme hh:mm:ss
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};

export const roundDate = (
  date: Date,
  formatString: string,
  roundValue: number
): Date => {
  if (roundValue <= 1) {
    return date;
  }

  const dateObj = new Date(date);

  if (formatString.includes('ss')) {
    // Arrondir les secondes
    const seconds = dateObj.getSeconds();
    const roundedSeconds = Math.floor(seconds / roundValue) * roundValue;
    dateObj.setSeconds(roundedSeconds);
  } else if (formatString.includes('mm')) {
    // Arrondir les minutes
    const minutes = dateObj.getMinutes();
    const roundedMinutes = Math.floor(minutes / roundValue) * roundValue;
    dateObj.setMinutes(roundedMinutes);
    dateObj.setSeconds(0); // Mettre les secondes à zéro
  } else if (formatString.includes('HH') || formatString.includes('hh')) {
    // Arrondir les heures
    const hours = dateObj.getHours();
    const roundedHours = Math.floor(hours / roundValue) * roundValue;
    dateObj.setHours(roundedHours);
    dateObj.setMinutes(0); // Mettre les minutes à zéro
    dateObj.setSeconds(0); // Mettre les secondes à zéro
  } else if (formatString.includes('dd')) {
    // Arrondir les jours
    const days = dateObj.getDate();
    const roundedDays = Math.floor(days / roundValue) * roundValue;
    dateObj.setDate(roundedDays);
    dateObj.setHours(0, 0, 0, 0); // Mettre les heures, minutes, secondes et millisecondes à zéro
  } else if (formatString.includes('MM')) {
    // Arrondir les mois
    const months = dateObj.getMonth();
    const roundedMonths = Math.floor(months / roundValue) * roundValue;
    dateObj.setMonth(roundedMonths);
    dateObj.setDate(1); // Mettre le jour à 1
    dateObj.setHours(0, 0, 0, 0); // Mettre les heures, minutes, secondes et millisecondes à zéro
  }

  return dateObj;
};
